import React from 'react';
// import { CardSwitcherPages, LoadingView, CardSwitcherHistory } from '@components';
import { Grid, Typography } from '@mui/material';
import { useAppSelector } from '@store/hooks';
import { selectorAuth } from '@core/slice/login.slice';
import { CardMenuHome } from '@components';
import { pages } from '@core/components/organisms/menu-items';
import { PathsEnum } from '@routes/enumerators/paths.enum';
import { HighlightBanners } from '@pages/home/components';
import bannerAppDesk from '@assets/banner-app-ouze-desk.png';
import bannerAppMob from '@assets/banner-app-ouze-mob.png';
import { podeAcessarPerformanceProdutos } from '@core/utils';

interface IViewsProps {}

export const Views: React.FC<IViewsProps> = () => {
    const {
        auth: { user }
    } = useAppSelector(selectorAuth);

    return (
        <>
            <HighlightBanners imageURL={{ bannerAppDesk: bannerAppDesk, bannerAppMob: bannerAppMob }} destinationLink="" isModal={false} imageTitle="Novo App Ouze" />
            <Grid sx={{ my: '1rem' }}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>Olá, {user?.primeiroNome}!</Typography>
            </Grid>
            <Grid sx={{ alignItems: 'center', justifyContent: 'center' }}>
                {pages.map((page) => {
                    if (page.path.split('/').length === 3 && page.path !== PathsEnum.COLABORADOR && page.visible && !page.path.startsWith('/varejo')) {
                        return <CardMenuHome key={page.name} title={page.name} route={page.path} disabled={page.disabled} />;
                    }
                    return null;
                })}
                {pages.map((page) => {
                    if (page.path.startsWith('/varejo') && page.visible && podeAcessarPerformanceProdutos(user)) {
                        console.log('show them');
                        return <CardMenuHome key={page.name} title={page.name} route={page.path} disabled={page.disabled} />;
                    }
                    return null;
                })}
            </Grid>
        </>
    );
};
